import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../config/constants";
import { jwtDecode } from "jwt-decode";

const items = [
  { label: "Wind", icon: "assets/card/wind.svg", color: "green" },
  { label: "Mains", icon: "assets/card/mains.svg", color: "red" },
  { label: "Bio Gas", icon: "assets/card/biogas.svg", color: "green" },
  { label: "Genset", icon: "assets/card/genset.svg", color: "gray" },
  { label: "Solar", icon: "assets/card/solar.svg", color: "gray" },
  { label: "ESS", icon: "assets/card/ess.svg", color: "gray" },
];

// Dummy card data (you can customize names, but icons/status stay same)
const dummySites = [
  { siteName: "Demo Site 1", siteURL: "", user_sites: { userId: "" } },
  { siteName: "Demo Site 2", siteURL: "", user_sites: { userId: "" } },
  { siteName: "Demo Site 3", siteURL: "", user_sites: { userId: "" } },
  { siteName: "Demo Site 4", siteURL: "", user_sites: { userId: "" } },
];

export default function Landing() {
  const token = localStorage.getItem("token");
  const deviceId = localStorage.getItem("deviceId");
  const [sites, setSites] = useState([]);
  const handleSiteClick = (site) => {
    if (!site.siteURL || !token || !site?.user_sites?.userId) {
      console.error("Missing data for navigation");
      return;
    }
    const finalURL = `${site.siteURL}?token=${encodeURIComponent(token)}&id=${site.user_sites.userId}`;
    window.location.href = finalURL;
  };

  useEffect(() => {
    const fetchSites = async () => {
      const stored = localStorage.getItem("state");
      if (!stored) {
        alert("Session expired. Please login again.");
        window.location.href = "/";
        return;
      }

      try {
        const res = await axios.post(
  `${API_BASE_URL}/redirect`,
  {},
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "device-id": deviceId,
    },
  }
);

//const urls = res.data || [];
//setSites({
  //sites: urls.map((url, index) => ({
   //siteName: index === 0 ? "Kagal-Microgrid" : "CMKL-Microgrid",
    //siteURL: url,
    //user_sites: { userId: JSON.parse(stored).id },
 // })),
//});
      const urls = res.data || [];
const stateData = JSON.parse(stored);
//const names = stateData.siteName || [];
const names = stateData.URL?.map((s) => s.siteName) || decoded.siteName || [];
const decoded = jwtDecode(token);  //newthingadded
setSites({
  sites: urls.map((url, index) => ({
   // siteName: names[index] || `Site ${index + 1}`,
        siteName: url.siteName || names[index] || `Site ${index + 1}`,
    //siteURL: url,
        //siteURL: url.siteURL || url,
       siteURL: url.siteURL || stateData.URL?.[index]?.siteURL || url,
      user_sites: { userId: stateData.id },
  })),
});
      } catch (err) {
        console.error("Failed to fetch sites:", err);
        alert("Failed to load sites. Please login again.");
        window.location.href = "/";
      }
    };

    if (!token) {
      alert("User expired. Please login again.");
      window.location.href = "/";
    } else {
      fetchSites();
    }
  }, [token]);

  // Combine real + dummy sites
  
  const displaySites = Array.isArray(sites) ? sites : sites?.sites || [];

  return (

    <div className="bg-[#051E1C] mx-[7.5rem] mt-[2rem] mb-[2.75rem] rounded-[0.625rem] h-[56.5rem]">
      <div className="mx-[11.0625rem] min-h-screen">
        <p className="text-[2rem] font-normal not-italic text-white mb-5 px-4 pt-[2.5rem]">
          Select State
        </p>

        {displaySites.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 site-grid">


            {displaySites.map((site, i) => (
              <div
                key={i}
                onClick={() => handleSiteClick(site)}
                className={`bg-[#072E2A] w-[26.125rem] h-[22.125rem] rounded-[25px] cursor-pointer overflow-hidden 
    ${!site.siteURL ? "cursor-not-allowed" : ""}`}  // removed opacity-70
              >
                {/* Header */}
                <div className="flex justify-between items-center mb-10">
                  <p className="text-white text-[1.5rem] font-semibold mt-[3.0625rem] ml-[2.6875rem]">
                    {site.siteName}
                  </p>
                  <div className="w-[2.5625rem] h-[2.5625rem] bg-[#2C4D4A] rounded-full flex items-center mt-[2.875rem] mr-[2rem] justify-center">
                    <span className="text-white text-2xl">↗</span>
                  </div>
                </div>

                {/* Icons Grid */}

                {/* Icons Grid */}
                <div className="grid grid-cols-3 gap-[1.25rem] ml-[2.6875rem] mr-[3.125rem] mb-[3.3125rem]">
                  {items.map((item, idx) => (
                    <div
                      key={idx}
                      className={`relative w-[5.9375rem] h-[5.3125rem] rounded-xl p-[1.375rem] flex flex-col items-center justify-center 
        ${!site.siteURL ? "bg-[#1A3E3A]" : "bg-[#2C4D4A]"}`} // dummy vs active
                    >
                      {/* Status dot - only for real sites */}
                      {site.siteURL && (
                        <div
                          className={`absolute top-3 left-3 w-[0.4375rem] h-[0.4375rem] rounded-full ${item.color === "green"
                            ? "bg-green-400"
                            : item.color === "red"
                              ? "bg-red-400"
                              : "bg-gray-400"
                            }`}
                        />
                      )}

                      <img
                        src={item.icon}
                        alt={item.label}
                        className={`w-[3.125rem] h-[3.125rem] ${!site.siteURL ? "opacity-50" : "opacity-100"}`}
                      // reduced opacity for dummy icons
                      />

                      <span className={`text-[0.8125rem] font-light text-white ${!site.siteURL ? "opacity-50" : "opacity-100"}`} >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>


              </div>

            ))}
          </div>
        ) : (
          <p className="text-white text-center text-lg">No sites available.</p>
        )}
      </div>
    </div>
  );
}
